<template>
    <div>
        <div class="container">
            <div class="row">
                <TitleArea :title="this.$t('menus.zkpsh.zra.title')" />
               <p>
                   {{this.$t('menus.zkpsh.zra.content')}}
               </p>
           </div>
            
        </div>
        
    </div>
</template>
<script>
import TitleArea from '@/components/share/TitleArea.vue';

export default {
  components: { TitleArea },
    data(){
        return{

        }
    },
    componnta:{
        TitleArea
    }
}
</script>
<style lang="">
    
</style>